import { AnimatePresence } from '@eversports/klimt-utilities/framer-motion'

import Footer from '../../components/Footer'
import Header from '../../components/Header'
import Search from '../../components/Search/Search'

import ActivityDetails from './ActivityDetails'

const ActivityDetailsPage = () => {
  return (
    <>
      <Header>
        <Search />
      </Header>
      <AnimatePresence mode="wait">
        <ActivityDetails />
      </AnimatePresence>
      <Footer />
    </>
  )
}

export default ActivityDetailsPage
